import { slugify, type TiptapContent } from '../util';
import type { UserProfile } from './users';

export const AcceleratorForums = {
  GENERAL_DISCUSSION: 'General Discussion',
  C1: 'C1',
  C2: 'C2',
} as const;

export type AcceleratorForum =
  (typeof AcceleratorForums)[keyof typeof AcceleratorForums];

export const PublicForums = {
  PRODUCT_IDEAS: 'Product Ideas',
  LOOKING_FOR_TEAM: 'Looking For Team',
  HACKATHON_TALK: 'Hackathon Talk',
  TECHNICAL_QUESTIONS: 'Technical Questions',
} as const;

export type PublicForum = (typeof PublicForums)[keyof typeof PublicForums];

export const AdminForums = {
  ADMIN_DISCUSSION: 'Admin Discussion',
} as const;

export type AdminForum = (typeof AdminForums)[keyof typeof AdminForums];

export const Forums = {
  ...AcceleratorForums,
  ...PublicForums,
  ...AdminForums,
} as const;

export type Forum = (typeof Forums)[keyof typeof Forums];

export const ForumType = {
  PUBLIC: 'PUBLIC',
  ACCELERATOR: 'ACCELERATOR',
  ADMIN: 'ADMIN',
} as const;

export type ForumType = (typeof ForumType)[keyof typeof ForumType];

export enum ForumTagName {
  DePIN = 'DePIN',
  DeFi = 'DeFi',
  Payments = 'Payments',
  Gaming = 'Gaming',
  Social = 'Social',
  DeveloperInfrastructure = 'Developer Infrastructure',
  SecurityTools = 'Security Tools',
  CommunityDAOs = 'Community DAOs',
  ConsumerOther = 'Consumer / Other',
}

export type ForumTag = { id: number; name: string };

export const FORUM_TAGS: Array<ForumTag> = [
  { id: 1, name: ForumTagName.DePIN },
  { id: 2, name: ForumTagName.DeFi },
  { id: 3, name: ForumTagName.Payments },
  { id: 4, name: ForumTagName.Gaming },
  { id: 5, name: ForumTagName.Social },
  { id: 6, name: ForumTagName.DeveloperInfrastructure },
  { id: 7, name: ForumTagName.SecurityTools },
  { id: 8, name: ForumTagName.CommunityDAOs },
  { id: 9, name: ForumTagName.ConsumerOther },
];

export interface ForumData {
  id: number;
  name: Forum;
  description: string;
  type: ForumType;
}

export interface ExtendedForumData extends ForumData {
  order: number;
}

export type ForumDataList = ForumData[];

export type ExtendedForumDataList = ExtendedForumData[];

export interface Post {
  id: number;
  user: UserProfile;
  createdAt: Date;
  updatedAt: Date;
  title: string;
  body: TiptapContent;
  likeCount: number;
  likedByCurrentUser: boolean;
  replyCount: number;
  tags: ForumTagName[];
  forum: ForumData;
}
export function getForumPath(forum: { type: string; name: string }) {
  return `/forums/${slugify(forum.type)}/${slugify(forum.name)}`;
}
